import { Box, Typography } from '@/ui';

export default function PoweredByIEHub() {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 0.75,
        py: 1.5,
      }}
    >
      <Typography
        sx={{
          color: '#999',
          fontSize: '0.8rem',
          fontWeight: 400,
        }}
      >
        Powered by
      </Typography>
      <Box
        component="a"
        href="https://www.iehub.co.uk/"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Visit IE Hub website (opens in a new tab)"
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          lineHeight: 0,
          borderRadius: 0.5,
          '&:focus-visible': {
            outline: '2px solid #003F44',
            outlineOffset: 2,
          },
        }}
      >
        <Box
          component="img"
          src="/icons/logo.png"
          alt="IE Hub"
          sx={{
            height: 22,
            width: 'auto',
            objectFit: 'contain',
            display: 'block',
          }}
        />
      </Box>
    </Box>
  );
}
